<template>
  <div id="userLogin">
    <div class="title">明基设计大赛</div>
    <div class="form">
      <el-form
        label-position="left"
        label-width="70px"
        :model="formData"
        :rules="rules"
        ref="uploadForm"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            v-model.number="formData.phone"
            placeholder=""
            class="input-code"
          ></el-input>
          <el-button
            size="small"
            type="primary"
            class="button-inline codebtn"
            @click="sendCodeEvent"
            :disabled="baseData.sec > 0"
            >{{
              baseData.sec > 0 ? `${baseData.sec}秒后可重发` : "发送验证码"
            }}</el-button
          >
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="formData.code"
            placeholder=""
            class="input-code"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            class="button-block"
            @click="formSubmitEvent"
            style="width: 400px"
            >登录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  sendVerificationCode,
  loginByCode,
  info,
} from "../utils/apis/userLoginApi";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  name: "userLogin",
  setup() {
    const router = useRouter();
    const route = useRoute();
    console.log(route.query.toUpload);
    const formData = reactive({
      phone: "",
      code: "",
    });
    const rules = reactive({
      phone: [
        { required: true, message: "请输入正确的手机号", trigger: "blur" },
        {
          pattern: /^1[3456789]\d{9}$/,
          message: "请输入正确的手机号",
          trigger: "blur",
        },
      ],
      code: [
        { required: true, message: "请输入6位验证码", trigger: "blur" },
        {
          pattern: /^\d{6}$/,
          message: "请输入6位验证码",
          trigger: "blur",
        },
      ],
    });
    const uploadForm = ref(null);
    let timer = ref(null);
    const baseData = reactive({
      sec: 0,
      showViewer: "",
    });
    /**
     * 倒计时
     */
    function countdownFn() {
      clearInterval(timer);
      timer = setInterval(() => {
        if (baseData.sec <= 0) {
          clearInterval(timer);
        } else {
          baseData.sec--;
        }
      }, 1000);
    }

    //发送验证码
    function sendCodeEvent() {
      //   loginByCode();
      console.log(baseData);
      if (baseData.sec > 0) {
        return;
      }
      uploadForm.value.validateField("phone", (err) => {
        if (!err) {
          baseData.sec = 90;
          countdownFn();
          sendVerificationCode({ phone: formData.phone }).then((res) => {
            if (res.data.code == 200) {
              ElMessage({
                message: "验证码已发送",
                type: "success",
                customClass: "myElMessage",
              });
            } else {
              baseData.sec = 0;
              ElMessage({
                message: res.data.message,
                type: "error",
                customClass: "myElMessage",
              });
            }
          });
        }
      });
    }

    //登录
    function formSubmitEvent() {
      uploadForm.value.validate((vaild) => {
        console.log(vaild);
        if (vaild) {
          console.log(vaild);
          loginByCode(formData).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              //   router.go(-1);
              console.log(res);
              localStorage.setItem("token", JSON.stringify(res.data.data));
              info().then((res) => {
                console.log(res);
                if (res.data.code === 200) {
                  localStorage.setItem(
                    "userInfo",
                    JSON.stringify(res.data.data)
                  );
                  if (route.query.toUpload != undefined) {
                    setTimeout(() => {
                      router.push({ path: "/upLoadFile" });
                    }, 1000);
                  } else {
                    setTimeout(() => {
                      router.push({ path: "/myWorks" });
                    }, 1000);
                  }
                }
              });
            } else if (
              res.data.code == 400 &&
              res.data.message == "该手机号未注册，请先注册。"
            ) {
              ElMessageBox.alert(res.data.message, {
                confirmButtonText: "确定",
                callback: (action) => {
                  if (action === "confirm") {
                    router.push({ path: "/signUp", query: { toMywork: true } });
                  }
                },
              });
            } else {
              ElMessage({
                message: res.data.message,
                type: "error",
                customClass: "myElMessage",
              });
            }
          });
        }
      });
    }
    return {
      formData,
      countdownFn,
      baseData,
      sendCodeEvent,
      uploadForm,
      rules,
      formSubmitEvent,
    };
  },
};
</script>

<style lang="less" scoped>
#userLogin {
  padding-top: 70px;
  width: 1200px;
  margin: 0 auto;
  .title {
    font-size: 36px;
    font-weight: bold;
    color: #303133;
    text-align: center;
    margin-bottom: 55px;
  }
  .form {
    width: 470px;
    margin: 0 auto;
    padding-bottom: 200px;
    .el-form-item__label {
      font-size: 14px;
      color: #303133;
    }
  }
  .protocol {
    vertical-align: -1px;
    color: #909399;
    margin-left: 10px;
    i {
      font-style: normal;
      cursor: pointer;
      transition: 0.2s;
    }
    i:hover {
      color: #003588;
    }
  }
  .input-code {
    width: 180px;
    margin-right: 20px;
  }
  .codebtn {
    width: 150px;
    height: 40px;
    background-color: #003588;
    color: #ffffff;
  }
}
</style>
